/**
 * @flow
 * */
import { createStore, compose, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
// import createLogger from 'redux-logger';

/**
 * @param {String} storeName - store name
 * @param {Array} rootReducer - combined reducers
 * @param {Array} controllers - controllers with saga
 * @param {Array} middlewares - middlewares
 * // @param {string} storeName - Store Name
 * @returns {Object} - store
 */
const dynamicallyCreateStore = (storeName: string, rootReducer: Object, controllers: Object, middlewares: Array<Function | null> = []) => {
  if (window[storeName]) {
    return window[storeName];
  }

  const initialState = {};
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const sagaMiddleware = createSagaMiddleware();

  /**
   * @returns {Array} - middleware
   */
  const switchMode = () => {
    if (process.env.NODE_ENV === 'development') {
      // return [sagaMiddleware, createLogger, ...middlewares];
      return [sagaMiddleware, ...middlewares];
    }

    return [sagaMiddleware, ...middlewares];
  };

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(...switchMode())
    )
  );

  if (controllers) sagaMiddleware.run(controllers);

  window[storeName] = store;
  return store;
};

export default dynamicallyCreateStore;
